import { Component, Input, OnInit, inject } from "@angular/core";
import { FormularGroupTabContentComponent } from "../tab-content.interface";
import { FormularGroupStamm } from "../../../formular-model/formular-groups/interfaces/FormularGroupStamm";
import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { StammElement } from "../../../formular-model/formular-groups/interfaces/stammelements/StammElement";
import { CommonKeys } from "../../../formular-model/common/enums";
import { FormularValidatorAjvProviderService } from "../../../formular-model/formular-model-validator.service";

@Component({
  selector: "tab-formular-group-stamm",
  templateUrl: "./stamm.component.html",
  styleUrls: ["./stamm.component.scss"],
  standalone: false,
})
export class FormularGroupTabStammComponent
  extends FormularGroupTabContentComponent<FormularGroupStamm>
  implements OnInit
{
  override formularGroupDataKey = "StammElemente";

  private _ajv = inject(FormularValidatorAjvProviderService);
  private _validate;

  get stammData() {
    return this.data[this.formularGroupDataKey][CommonKeys.Values];
  }
  get controls() {
    return (this.form.controls[this.formularGroupDataKey] as FormArray)
      .controls;
  }

  public getDataItem(key: string) {
    return this.data[this.formularGroupDataKey][key];
  }

  public getStammByIndex(index: number) {
    return this.data[this.formularGroupDataKey][index];
  }

  constructor() {
    super();
    this._validate = this._ajv.getSchema("FormularGroupStammSchema");
  }

  ngOnInit(): void {
    this.__dataInternal = { ...this.data };

    const ctlArray = new FormArray<FormControl>([]);
    this.form.addControl(this.formularGroupDataKey, ctlArray);

    this.data[this.formularGroupDataKey][CommonKeys.Values].forEach(
      (e: StammElement) => {
        const ctl = new FormControl({
          value: e[CommonKeys.Value],
          disabled: e[CommonKeys.IsReadonly] ?? false,
        });

        ctlArray.push(ctl);
      },
    );
  }

  public reconstructData() {
    for (let i = 0; i < this.controls.length; i++) {
      this.__dataInternal[this.formularGroupDataKey][CommonKeys.Values][i][
        CommonKeys.Value
      ] = this.controls[i].value || null;
    }

    const res = {
      [CommonKeys.Type]: this.data[CommonKeys.Type],
      [CommonKeys.ID]: this.data[CommonKeys.ID],
      [CommonKeys.Label]: this.data[CommonKeys.Label],
      [CommonKeys.ShowLabel]: this.data[CommonKeys.ShowLabel],
      StammElemente: this.__dataInternal[this.formularGroupDataKey],
    };

    if (this._assertGroupStamm(res)) {
      return res;
    }

    throw new Error("Group Stamm failed validation on returning data");
  }

  private _assertGroupStamm(data: any): data is FormularGroupStamm {
    if (!this._validate(data)) {
      console.error(
        `Group Stamm didn't pass validation on returning data:`,
        data,
        this._validate.errors,
      );
      return false;
    }

    return true;
  }
}
